import { ValidationError } from "sequelize"
import {
    QidModelOption,
    QidModelOptionCreate,
    QidModelOptionSave,
} from "server/models"
import { GET, POST, DELETE, validate } from "client/store/utils"
import {
    LangType,
    QidModelOptionValidation,
    UpdateQidDependingDevices,
} from "client/store"


export const LoadQidModelOptionById = (optionId: number) => (
    GET(`/qidModelOption/id/${optionId}`)
    .then((option: QidModelOption) => option)
)

export const SaveQidModelOption = (
    id: number,
    option: QidModelOptionCreate,
    updated: boolean,
    lang: LangType,
) => {
    const data: QidModelOptionSave = {
        id,
        option,
    }
    return POST(
        "/qidModelOption/save",
        JSON.stringify(data),
    ).then((res) => {
        const newOption = res as QidModelOption
        const error = res as ValidationError
        const validation = <QidModelOptionValidation>validate(error, lang)

        const result = {
            newOptionId: newOption.id || null,
            validation,
        }

        if (!validation && id && updated) {
            // update SIL project devices
            return UpdateQidDependingDevices({
                update: true,
                qidOptionId: id,
            }).then(() => result)
        }
        return result
    })
}

export const DeleteQidModelOption = (optionId: number, safetyFunctionId: number, modelId: number, productId: number) => (
    DELETE(`/qidModelOption/delete/${optionId}`)
    .then((removedRows: number) => {
        if (removedRows === 1) {
            // update SIL project devices
            return Promise.all([
                UpdateQidDependingDevices({
                    update: false,
                    qidProductId: productId,
                    qidModelId: modelId,
                    qidSafetyFunctionId: safetyFunctionId,
                    qidOptionId: optionId,
                }),
                UpdateQidDependingDevices({
                    update: true,
                    qidProductId: productId,
                    qidModelId: modelId,
                    qidSafetyFunctionId: safetyFunctionId,
                    qidOptionId: null,
                }),
                UpdateQidDependingDevices({
                    update: true,
                    qidProductId: productId,
                    qidModelId: modelId,
                    qidSafetyFunctionId: null,
                }),
                UpdateQidDependingDevices({
                    update: true,
                    qidProductId: productId,
                    qidModelId: null,
                }),
            ]).then(() => removedRows)
        }
        return removedRows
    })
)
